import React, {
  useMemo,
} from 'react';
import isEmpty from 'lodash/isEmpty';
import {
  FormCategoryDTO,
} from 'dtos';
import Pill from 'core/components/Pill';
import ToolTip from 'core/components/Tooltip';

type Props = {
  formCategories?: FormCategoryDTO[] | null;
};

export default function FormCategoryCell({
  formCategories,
}: Props) {
  const categories = useMemo(() => formCategories ?? [], [formCategories]);
  const [primary, ...remainder] = categories;

  return isEmpty(categories) ? (
    <span className="text-gray-400">—</span>
  ) : (
    <div className="flex items-center gap-1 truncate">
      <span className="truncate">{primary?.name}</span>
      {remainder.length > 0 && (
        <ToolTip
          title={(
            <div className="flex flex-col gap-1 p-1">
              {remainder.map((category) => (
                <span key={category.value ?? category.name}>{category.name}</span>
              ))}
            </div>
          )}
          isInteractive
        >
          <span className="!cursor-pointer !pointer-events-auto shrink-0">
            <Pill label={`+${remainder.length}`} />
          </span>
        </ToolTip>
      )}
    </div>
  );
}
